var React = require('react');

function IconLeftArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Left Arrow icon"),React.createElement("desc",{"key":1},"Left Arrow icon"),React.createElement("polygon",{"fill":"#3F7BAB","points":"3 12.5 3 13.5 13.5 13.5 13.5 3 12.5 3 12.5 12.5","transform":"scale(-1 1) rotate(-45 1.828 37.41)","key":2})]);
}

IconLeftArrow.displayName = "IconLeftArrow";

IconLeftArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img"};

module.exports = IconLeftArrow;

IconLeftArrow.default = IconLeftArrow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./app/javascript/images/icons/icon-left-arrow.svg
// module id = 779
// module chunks = 0 1 2